// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  ICertificationProcedureApi,
  ICertificationProcedureApiRequest,
  ICertificationProcedureApiGetAllAttrs,
  ICertificationProcedureApiGetAllResponse,
  ICertificationProcedureApiGetAttrs,
  ICertificationProcedureApiGetResponse,
  ICertificationProcedureApiSaveAttrs,
  ICertificationProcedureApiSaveResponse,
} from 'interfaces/back-office/content-management/certification/procedure/certification-procedure-api.interface'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'
import { IBaseApiRequestPayload } from 'interfaces/api'

export class CertificationProcedureApi extends BaseApi<ICertificationProcedureApi> implements ICertificationProcedureApiRequest {
  readonly url = ApiConstant.CONTENT_CERTIFICATION_PROCEDURE_URL
  private certificationProcedureUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get home welcomes
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationProcedureApiGetAllAttrs} payload
   *
   * @return {Promise<ICertificationProcedureApiGetAllResponse>} Promise<ICertificationProcedureApiGetAllResponse>
   */
  async certificationProcedure_getCertificationProcedures(
    payload: ICertificationProcedureApiGetAllAttrs,
  ): Promise<ICertificationProcedureApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.certificationProcedureUrl}/list`, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get home welcome
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationProcedureApiGetAttrs} payload
   *
   * @return {Promise<ICertificationProcedureApiGetResponse>} Promise<ICertificationProcedureApiGetResponse>
   */
  async certificationProcedure_getCertificationProcedure(
    payload: ICertificationProcedureApiGetAttrs,
  ): Promise<ICertificationProcedureApiGetResponse> {
    try {
      const response = await this.POST(`${this.certificationProcedureUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home welcome
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationProcedureApiSaveAttrs} payload
   *
   * @return {Promise<ICertificationProcedureApiSaveResponse>} Promise<ICertificationProcedureApiSaveResponse>
   */
  async certificationProcedure_saveCertificationProcedure(
    payload: ICertificationProcedureApiSaveAttrs,
  ): Promise<ICertificationProcedureApiSaveResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: `${this.certificationProcedureUrl}/update/${payload.params.id}`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
